var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentApiLightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.8834mm",
    height: "12mm",
    viewBox: "0 0 30.85059 34.01575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a {\n        fill: #fff;\n      }\n\n      .b {\n        fill: #4b9fd8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.08617,6.33031A2.42532,2.42532,0,0,0,20.1194,7.34088H9.72066a2.4342,2.4342,0,1,0,.00016,2.84684H20.11921a2.43152,2.43152,0,1,0,1.967-3.85741Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.41645,6.33031a2.429,2.429,0,0,0-1.42373,4.40077V29.49282a1.678,1.678,0,0,1-1.6761,1.67609H4.52324a1.67822,1.67822,0,0,1-1.67641-1.67609V5.53381a1.67823,1.67823,0,0,1,1.67641-1.6761H20.1194a2.43415,2.43415,0,1,0-.00023-2.84683H4.52324A4.52817,4.52817,0,0,0,0,5.53381v23.959a4.52817,4.52817,0,0,0,4.52324,4.52293H25.31662a4.52792,4.52792,0,0,0,4.52294-4.52293V10.73154a2.429,2.429,0,0,0-1.42311-4.40123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.08617,12.66063a2.42515,2.42515,0,0,0-1.967,1.01088H9.72089a2.43421,2.43421,0,1,0-.00031,2.84683H20.11944a2.43152,2.43152,0,1,0,1.96673-3.85771Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentApiLightSmall);
export default __webpack_public_path__ + "static/media/document-api_light_small.7aa71d85a85c89dedf70ad30899caef1.svg";
export { ForwardRef as ReactComponent };